export const isLocalStorageEmpty = (): boolean => {
  return localStorage.length === 0;
};
